module.exports = __webpack_public_path__ + "img/firefox.e559a1ce.svg";